import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  AfterContentChecked,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalSearchResponse, ServiceResult } from '@data/schema/global-search-response';
import { GlobalSearchService } from '@gah-core/services/global-search.service';
import { UserStoreService } from '@gah-core/services/user-store.service';
import { Subject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-global-search',
  templateUrl: './global-search.component.html',
  styleUrls: ['./global-search.component.scss'],
})
export class GlobalSearchComponent implements OnInit, AfterViewInit, AfterContentChecked {
  @ViewChild('gahGlobalSearchInput', { static: true }) inputRef: ElementRef<HTMLInputElement>;
  @ViewChild(MatAutocompleteTrigger, { read: MatAutocompleteTrigger })
  autocomplete: MatAutocompleteTrigger;
  searchForm: FormGroup;
  searchSubscription: Subscription;
  navigationSubscription: Subscription;
  routeSubscription: Subscription;
  searchTextSubject$ = new Subject<{
    searchKeyword: string;
    groupTypeCd: string;
    territoryId: number;
    autoSuggestion: boolean;
  }>();
  results: ServiceResult[] = [];
  isLoading: boolean = false;
  isSearchClose: boolean = false;
  searchKeyword: FormControl;

  constructor(
    private fb: FormBuilder,
    private globalSearchService: GlobalSearchService,
    private userStoreService: UserStoreService,
    private router: Router,
    private cdref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      searchKeyword: [''],
    });
    this.searchKeyword = new FormControl(['']);
  }

  toggle() {
    this.isSearchClose = !this.isSearchClose;
    this.cdref.detectChanges();
  }

  ngAfterViewInit(): void {
    this.cdref.detectChanges();
    this.searchSubscription = this.searchTextSubject$
      .asObservable()
      .pipe(tap(() => (this.isLoading = true)))
      .subscribe();
    this.globalSearchService
      .getSearchResults(this.searchTextSubject$)
      .subscribe((res: GlobalSearchResponse) => {
        this.results = res.serviceResult ?? [];
        this.isLoading = false;
      });
    this.globalSearchService.getSearchValue().subscribe((searchVal) => {
      setTimeout(() => {
        this.setFormValue(searchVal);
      }, 100);
      this.isSearchClose = searchVal ? false : true;
      this.cdref.detectChanges();
      this.results = [];
    });
  }

  onChangeValue(event) {
    let reqData = {
      searchKeyword: event.target.value,
      groupTypeCd: this.userStoreService.userState.selectedTerritory?.groupTypeCode,
      territoryId: this.userStoreService.userState.selectedTerritory?.territoryId,
      autoSuggestion: true,
    };
    this.searchTextSubject$.next(reqData);
  }

  onSubmit() {
    let searchValue = this.searchForm.value.searchKeyword ?? '';
    if (searchValue.trim().length >= 1) {
      this.router.navigate(['global-search'], { queryParams: { search: searchValue } });
    }
  }

  selectedSearchItem(value) {
    let selectedOption = value ?? null;
    if (selectedOption) {
      let url = '';
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.formReset();
      if (selectedOption.type === 'Asset') {
        url = `assets/${selectedOption.title_id}/preview/${selectedOption.runner_asset_release_id}`;
      } else {
        url = `assets/${selectedOption.title_id}`;
      }
      this.router.navigate([url]);
    }
  }

  displaySearchText(option) {
    if (option) return option.name;
  }

  setFormValue(searchValue) {
    this.searchKeyword.setValue(searchValue, { emitModelToViewChange: false, emitEvent: false });
    this.inputRef.nativeElement.value = searchValue;
    this.autocomplete.openPanel();
  }

  formReset() {
    this.isSearchClose = true;
    this.cdref.detectChanges();
    this.results = [];
    this.searchForm.reset();
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnDestroy() {
    this.searchTextSubject$.next();
    this.searchTextSubject$.complete();
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
